export default "__VITE_PUBLIC_ASSET__482ff63c__"